import { Component, Input, Output, EventEmitter } from '@angular/core';
import { QPilotProduct } from '../../types/product';
import { BundleProductListItemComponent } from '../bundle-product-list-item/bundle-product-list-item.component';
import { CommonModule } from '@angular/common';
import { BundleProductDto, IBundle } from '../bundle.interfaces';

@Component({
  selector: 'lib-bundle-product-list',
  standalone: true,
  imports: [CommonModule, BundleProductListItemComponent],
  templateUrl: './bundle-product-list.component.html',
  styleUrl: './bundle-product-list.component.scss',
})
export class BundleProductListComponent {
  @Input() products: BundleProductDto[] = [];
  @Input() bundle: IBundle;
  @Input() orderVerboseName: string;
  @Input() selectedProducts: BundleProductDto[] = [];
  @Input() bundleSize: number;
  @Output() increment = new EventEmitter<BundleProductDto>();
  @Output() decrement = new EventEmitter<BundleProductDto>();
}
